module.exports = __webpack_public_path__ + "img/black-info-icon.66747b5c.svg";